// wrapGroup — VQE-Edit edit-action: wrap a contiguous run of a WHERE group's
// children [fromIndex..toIndex] in new parentheses. Delegates to SR-Edit
// `wrap-group` via `commitEdit`.

import type { BooleanClauseTarget, NodePath } from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Wrap the sibling run `[fromIndex, toIndex]` (inclusive) of the group at
 * `parentPath` in a new `( … )` group, in the WHERE (default) or HAVING
 * (`clause: 'having'`) tree. No-op (SR-Edit returns no planned edits) when the
 * indices are out of range or `fromIndex > toIndex`.
 */
export async function wrapGroup(
  parentPath: NodePath,
  fromIndex: number,
  toIndex: number,
  ctx: CommitEditCtx,
  clause?: BooleanClauseTarget,
): Promise<void> {
  await commitEdit({ op: 'wrap-group', parentPath, fromIndex, toIndex, clause }, ctx);
}
